import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import lottie from 'lottie-web'

import cn from '../../libs/class-name'

const Animation = ({ classNames, animationData }) => {
  const [show, setShow] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    })

    animation.addEventListener('DOMLoaded', () => setShow(true), false)
  }, [])

  return (
    <div ref={containerRef} className={cn('Animation', { show }, classNames)} />
  )
}

Animation.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  animationData: PropTypes.object.isRequired
}

export default Animation
